function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDE494"
    },
    d: "M6.724 30h3.58l-5.649 -3.621 -4.644 -2.713C0.214 27.193 3.147 30 6.724 30"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEA150"
    },
    d: "m19.655 27.931 -4.043 -1.034H6.724c-1.996 0 -3.621 -1.624 -3.621 -3.621v-1.985l-1.552 -1.665L0 19.9v3.376c0 0.131 0.004 0.261 0.012 0.39L10.304 30h12.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5D4A"
    },
    d: "M25.878 25.789c-0.659 0.682 -1.582 1.107 -2.602 1.107H15.612L22.537 30h0.739c2.414 0 4.535 -1.279 5.721 -3.195l-1.583 -0.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E45261"
    },
    d: "M26.897 19.102v4.174c0 0.976 -0.389 1.862 -1.018 2.514l3.119 1.016C29.633 25.779 30 24.569 30 23.276v-3.68l-1.605 -0.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4D95"
    },
    points: "512,149.19 483.797,142.474 459.034,157.3 459.034,326.014 512,334.436 ",
    d: "M30 8.742L28.347 8.348L26.897 9.217L26.897 19.102L30 19.596Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB319C"
    },
    d: "M30 6.724c0 -3.377 -2.502 -6.18 -5.75 -6.653L20.181 1.764l-2.062 1.34h5.156c1.996 0 3.621 1.624 3.621 3.621V9.217L30 8.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8A3293"
    },
    d: "M18.617 0 14.769 1.444l-3.035 1.66h6.387L24.25 0.071A6.738 6.738 0 0 0 23.276 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5D4A"
    },
    d: "M15 23.793c1.076 0 2.107 -0.195 3.06 -0.55l-5.04 -2.288 -5.342 -1.093c1.577 2.367 4.271 3.931 7.323 3.931"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E45261"
    },
    d: "M19.286 17.892c-0.931 1.375 -2.505 2.28 -4.286 2.28 -2.36 0 -4.354 -1.589 -4.973 -3.753l-1.388 -0.867 -2.393 0.266a8.738 8.738 0 0 0 1.431 4.044l10.383 3.381c2.244 -0.836 4.057 -2.564 5.007 -4.75l-1.861 -0.942z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4D95"
    },
    d: "M9.828 15c0 -1.282 0.47 -2.455 1.245 -3.36l-2.207 -0.309 -2.241 0.99A8.76 8.76 0 0 0 6.207 15c0 0.276 0.014 0.549 0.039 0.818l3.781 0.601A5.156 5.156 0 0 1 9.828 15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4D95"
    },
    d: "M23.793 15c0 -1.883 -0.595 -3.63 -1.607 -5.062l-2.191 -0.311 -2.251 0.991c1.457 0.916 2.429 2.537 2.429 4.382 0 1.071 -0.327 2.066 -0.886 2.892l3.781 0.601A8.742 8.742 0 0 0 23.793 15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB319C"
    },
    d: "M15 9.828c1.007 0 1.948 0.291 2.744 0.791l4.442 -0.68c-1.594 -2.255 -4.221 -3.731 -7.186 -3.731 -3.915 0 -7.239 2.572 -8.375 6.114l4.448 -0.681c0.949 -1.108 2.357 -1.812 3.927 -1.812"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB319C"
    },
    d: "M23.276 8.793c1.141 0 2.069 -0.928 2.069 -2.069s-0.928 -2.069 -2.069 -2.069 -2.069 0.928 -2.069 2.069 0.928 2.069 2.069 2.069"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5D4A"
    },
    points: "52.966,313.564 27.47,300.847 0,296.316 0,339.629 52.966,363.366 ",
    d: "M3.103 18.373L1.61 17.628L0 17.362L0 19.9L3.103 21.291Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E45261"
    },
    points: "0,253.014 0,296.316 52.966,313.564 52.966,261.437 25.446,251.543 ",
    d: "M0 14.825L0 17.362L3.103 18.373L3.103 15.319L1.491 14.739Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4D95"
    },
    points: "52.966,219.479 25.749,219.233 0,227.59 0,253.014 52.966,261.437 ",
    d: "M3.103 12.86L1.509 12.846L0 13.335L0 14.825L3.103 15.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB319C"
    },
    points: "52.966,179.757 24.911,182.603 0,205.962 0,227.59 52.966,219.479 ",
    d: "M3.103 10.533L1.46 10.699L0 12.068L0 13.335L3.103 12.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8A3293"
    },
    points: "0,205.962 52.966,179.757 52.966,119.362 21.9,122.333 0,143.241 ",
    d: "M0 12.068L3.103 10.533L3.103 6.994L1.283 7.168L0 8.393Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#523494"
    },
    d: "M12.015 0 4.934 2.723 0.081 5.679A6.738 6.738 0 0 0 0 6.724v1.669l3.103 -1.399v-0.27c0 -1.996 1.624 -3.621 3.621 -3.621h5.009L18.617 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D2D87"
    },
    d: "M6.724 0C3.372 0 0.585 2.466 0.081 5.679L12.015 0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d7386b7ff0272c29c968b92cf3f6da29.svg";
export { ForwardRef as ReactComponent };